import { StyleSheet } from 'react-native'; 
import { MediaQueryStyleSheet } from "react-native-responsive";
import { PALETTE } from '../../../../constants';

export default MediaQueryStyleSheet.create({
    textInput:{
        height: 100, 
        borderColor: 'gray', 
        borderWidth: 1,
        backgroundColor:'white',
        borderRadius:3,
        marginBottom:5,
        color:'black',
        padding: 10,
   },
   root: {
        backgroundColor: PALETTE.successColor,
    },
    text: {
        textAlign: 'center',
    },
    container: {
        flex: 1,
        backgroundColor: 'transparent',
    },
});

